import { CssBaseline, styled, ThemeProvider } from '@mui/material';
import { ApolloProvider } from '@apollo/client';
import { SnackbarProvider } from 'notistack';
import AppRoute from './router';
import { client } from './graphql';
import theme from './theme';

const Root = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
}));

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Root>
        <CssBaseline />
        <SnackbarProvider maxSnack={3}>
          <ApolloProvider client={client}>
            <AppRoute />
          </ApolloProvider>
        </SnackbarProvider>
      </Root>
    </ThemeProvider>
  );
}

export default App;
